import { render } from "./AposInputSlug.vue?vue&type=template&id=2c1fba8c&scoped=true"
import script from "./AposInputSlug.vue?vue&type=script&lang=js"
export * from "./AposInputSlug.vue?vue&type=script&lang=js"

import "./AposInputSlug.vue?vue&type=style&index=0&id=2c1fba8c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c1fba8c"],['__file',"schema/ui/apos/components/AposInputSlug.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c1fba8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c1fba8c', __exports__)) {
    api.reload('2c1fba8c', __exports__)
  }
  
  module.hot.accept("./AposInputSlug.vue?vue&type=template&id=2c1fba8c&scoped=true", () => {
    api.rerender('2c1fba8c', render)
  })

}


export default __exports__